import { PageHeader } from './PageHeader';
import { PageHeaderTitle } from './PageHeaderTitle';

PageHeader.Title = PageHeaderTitle;

export { PageHeader };
